<template>
  <b-row>
    <!-- left align -->
    <template v-for="(r_items, index) in items">
      <b-col md="6" lg="4" v-if="r_items.level === 4" :key="index">
        <b-card
          bg-variant="primary"
          text-variant="white"
        >
          <b-card-title class="text-white">
            {{ r_items.name }}
          </b-card-title>
          <b-card-text class="text-white">
            &nbsp;<!-- With supporting text below as a natural lead-in to additional content. {{ r_items.url }} -->
          </b-card-text>
          <b-link :to="{ path: r_items.url }">
            <b-button variant="relief-secondary">
              Open
            </b-button>
          </b-link>
        </b-card>
      </b-col>
    </template>
  </b-row>
</template>
<script>
import { BRow, BLink, BCol, BCard, BCardTitle, BCardText, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapState } from 'vuex'
export default {
  components: { BRow, BLink, BCol, BCard, BCardTitle, BCardText, BButton },
  computed: {
    ...mapState({ 
      items: state => state.profile.items, 
    })
  },
  directives: {
    Ripple
  },
  created () {
    this.$store.dispatch('profile/getPrivilege')
  }
}
</script>